import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSketch12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconSketch12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="m6.024 2.001 2.745.305a.2.2 0 0 1 .146.082l2.044 2.706a.204.204 0 0 1-.01.257L6.08 10.964a.107.107 0 0 1-.16 0L1.05 5.35a.204.204 0 0 1-.009-.257l2.044-2.706a.2.2 0 0 1 .146-.082L5.976 2a.2.2 0 0 1 .048 0m.57.584a.045.045 0 0 0-.06-.003.043.043 0 0 0-.01.056l.003.005 1.549 1.894a.1.1 0 0 1 .023.065.104.104 0 0 1-.097.103H4.006a.1.1 0 0 1-.065-.022.1.1 0 0 1-.022-.138l.005-.008 1.549-1.894a.043.043 0 0 0-.003-.058.045.045 0 0 0-.059-.004l-.005.004L3.31 4.657a.1.1 0 0 1-.064.025.083.083 0 0 1-.08-.079v-.008l.072-1.5a.042.042 0 0 0-.081-.016l-.002.004-.397 1.728a.17.17 0 0 1-.118.122l-.01.003-.985.208a.04.04 0 0 0-.033.04c0 .022.016.039.036.042h.988a.17.17 0 0 1 .14.075l.006.01 2.355 4.127c.016.028.052.04.082.026a.06.06 0 0 0 .033-.076l-.003-.007-1.903-3.978a.1.1 0 0 1-.012-.053c0-.065.051-.12.117-.124H8.54q.029 0 .054.012c.06.028.088.096.064.157l-.004.008L6.752 9.38a.06.06 0 0 0 .026.08.064.064 0 0 0 .082-.017l.004-.006L9.219 5.31a.17.17 0 0 1 .135-.084h.993c.02 0 .037-.014.041-.033a.04.04 0 0 0-.027-.047l-.005-.002-.984-.208a.17.17 0 0 1-.126-.114l-.003-.011-.397-1.728a.04.04 0 0 0-.043-.032.04.04 0 0 0-.04.037v.006l.072 1.501a.08.08 0 0 1-.025.063.085.085 0 0 1-.112.005l-.007-.006z"
            />
        </svg>
    );
}
export default memo(IconSketch12);
